import { cloneDeep } from 'lodash';

import { TicketCategory1 } from '@work4all/models/lib/Classes/TicketCategory1.entity';
import { TicketKind } from '@work4all/models/lib/Classes/TicketKind.entity';
import { Topic } from '@work4all/models/lib/Classes/Topic.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

import { extendGeneralSettingsSchema } from '../../utils/lookup-type-mapping';

import { GeneralSettingsTable } from './general-settings-table/GeneralSettingsTable';
import { LookUpTable } from './LookUpTable';
import ticketCategory1Schema from './schemata/ticketCategory1-table-schema.json';

// Simple lookup tables using the generic LookUpTable component
export const RelationsTable = () => {
  return <LookUpTable lookupType={LookupType.BEZIEHUNGEN} />;
};

export const TicketChecklistTable = () => {
  return <LookUpTable lookupType={LookupType.TICKET_CHECKLISTENPUNKT} />;
};

export const TicketCategory2Table = () => {
  return <LookUpTable lookupType={LookupType.TICKET_KATEGORIE_2} />;
};

// TODO: WW-7296 for numberlogic & country
export const TicketCategory1Table = () => (
  <GeneralSettingsTable<TicketCategory1>
    entityType={Entities.ticketCategory1}
    schema={ticketCategory1Schema}
  />
);

const ticketKindBaseSchema = cloneDeep(ticketCategory1Schema);
ticketKindBaseSchema.entity = Entities.ticketKind;
ticketKindBaseSchema.entityNameDE = 'Ticketart';

const ticketKindSchema = extendGeneralSettingsSchema(
  ticketKindBaseSchema,
  Entities.ticketKind
);

export const TicketKindTable = () => (
  <GeneralSettingsTable<TicketKind>
    entityType={Entities.ticketKind}
    schema={ticketKindSchema}
  />
);

const topicSimpleSchema = cloneDeep(ticketCategory1Schema);
topicSimpleSchema.entity = Entities.topic;

export const TopicTable = () => (
  <GeneralSettingsTable<Topic>
    entityType={Entities.topic}
    schema={topicSimpleSchema}
    enableLocalFiltering={false}
  />
);

export const AddressLinksTable = () => {
  return <LookUpTable lookupType={LookupType.ADRESSVERKNUEPFUNG} />;
};

export const BranchOfficesTable = () => {
  return <LookUpTable lookupType={LookupType.NIEDERLASSUNGEN} />;
};

export const ProjectKindTable = () => {
  return <LookUpTable lookupType={LookupType.PROJEKT_TYPE} />;
};

export const ProjectStatusTable = () => {
  return <LookUpTable lookupType={LookupType.PROJEKT_STATI} />;
};

export const ResourceClassTable = () => {
  return <LookUpTable lookupType={LookupType.RESSOURCENKLASSEN} />;
};
